import {
  ROUTE_SPORTS,
  ROUTE_SPORTS_EN,
  ROUTE_FOOTBALL,
  ROUTE_FOOTBALL_EN,
} from './home.routes';
import { Routes } from '@angular/router';
import { CompetitionDetailsComponent } from '../pages/competition-details/competition-details.component';
import { MatchDetailsComponent } from '../pages/match-details/match-details.component';
import { TeamDetailsComponent } from '../pages/team-details/team-details.component';
import { SportGuard } from '../services/redirect/sport-guard';
import { FootballMatchDetailsComponent } from '../pages/sports/football/match-details/match-details.component';
import { FootballTeamDetailsComponent } from '../pages/sports/football/team-details/team-details.component';
import { FootballCompetitionDetailsComponent } from '../pages/sports/football/competition-details/competition-details.component';

export const ROUTE_FOOTBALL_MATCHS = `${ROUTE_FOOTBALL}/partido/:slug/:matchId`;
export const ROUTE_FOOTBALL_MATCHS_EN = `${ROUTE_FOOTBALL_EN}/match/:slug/:matchId`;
export const ROUTE_FOOTBALL_TEAMS = `${ROUTE_FOOTBALL}/equipo/:slug/:teamId`;
export const ROUTE_FOOTBALL_TEAMS_EN = `${ROUTE_FOOTBALL_EN}/team/:slug/:teamId`;
export const ROUTE_FOOTBALL_COMPETITIONS = `${ROUTE_FOOTBALL}/liga/:slug/:competitionId`;
export const ROUTE_FOOTBALL_COMPETITIONS_EN = `${ROUTE_FOOTBALL_EN}/league/:slug/:competitionId`;

export const ROUTE_SPORTS_MATCHS =
  'partido/:sport/:id/:idHome/:idAway/:idCompetition/:date';
export const ROUTE_SPORTS_MATCHS_EN =
  'en/match/:sport/:id/:idHome/:idAway/:idCompetition/:date';
export const ROUTE_SPORTS_TEAMS = `${ROUTE_SPORTS}/:country/equipo/:teamName/:idTeam`;
export const ROUTE_SPORTS_TEAMS_EN = `${ROUTE_SPORTS_EN}/:country/team/:teamName/:idTeam`;
export const ROUTE_SPORTS_COMPETITIONS = `${ROUTE_SPORTS}/:country/liga/:leagueName/:idCompetition`;
export const ROUTE_SPORTS_COMPETITIONS_EN = `${ROUTE_SPORTS_EN}/:country/league/:leagueName/:idCompetition`;

export const detailsRoutes: Routes = [
  {
    path: ROUTE_FOOTBALL_MATCHS,
    loadComponent: () => FootballMatchDetailsComponent,
  },
  {
    path: ROUTE_FOOTBALL_MATCHS_EN,
    loadComponent: () => FootballMatchDetailsComponent,
  },
  {
    path: ROUTE_FOOTBALL_TEAMS,
    loadComponent: () => FootballTeamDetailsComponent,
  },
  {
    path: ROUTE_FOOTBALL_TEAMS_EN,
    loadComponent: () => FootballTeamDetailsComponent,
  },
  {
    path: ROUTE_FOOTBALL_COMPETITIONS,
    loadComponent: () => FootballCompetitionDetailsComponent,
  },
  {
    path: ROUTE_FOOTBALL_COMPETITIONS_EN,
    loadComponent: () => FootballCompetitionDetailsComponent,
  },
  // old routes
  {
    path: ROUTE_SPORTS_MATCHS,
    loadComponent: () => MatchDetailsComponent,
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_MATCHS_EN,
    loadComponent: () => MatchDetailsComponent,
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_TEAMS,
    loadComponent: () => TeamDetailsComponent,
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_TEAMS_EN,
    loadComponent: () => TeamDetailsComponent,
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_COMPETITIONS,
    loadComponent: () => CompetitionDetailsComponent,
    canActivate: [SportGuard],
  },
  {
    path: ROUTE_SPORTS_COMPETITIONS_EN,
    loadComponent: () => CompetitionDetailsComponent,
    canActivate: [SportGuard],
  },
];
